'use strict';

function applyAppOptions(target) {
  // APP

  /**
   * @prop {string} [app.name]
   * String containing the name of the app
   */
  target['app.name'] = undefined;

  /**
   * @prop {string} [app.releaseVerson]
   * String containing the app version
   */
  target['app.releaseVersion'] = undefined;

  /**
   * @prop {boolean} [app.https=true]
   * Define the security of NQS calls.
   * If true it will use 'https://',
   * if false it will use 'http://',
   * if null/undefined it will use '//'.
   */
  target['app.https'] = true;
}

module.exports = applyAppOptions;

